import { LOADING_UPDATE } from '@/store/actions/loading/action-typs';

const initialState = Object.assign({}, {
  status: false
});

const reducer = (state = initialState, { type, payload = null }) => {
  switch (type) {
    case LOADING_UPDATE:
      return updateLoading(state, payload);
    default:
      return state;
  }
};

function updateLoading(state, payload) {
  return {
    ...state,
    status: payload
  };
}


export default reducer;
